export class AdminPanel_Parameters {
     logo?: string;
     phoneToCall?: string;
     phoneToSendToInform1?: string;
     phoneToSendToInform2?: string;
     phoneToSendonCancel1?: string;
     phoneToSendonCancel2?: string;
     afterConfMsg?: string;
     showCallOption?: boolean;
     showCancelOption?: boolean;
     canSendSmsToInform?: boolean;
     canSendSmsonCancel?: boolean;
     allowCancelBeforeHours?: number;
}